import { render, staticRenderFns } from "./ass_goods_list.vue?vue&type=template&id=d01e4f4a&scoped=true&"
import script from "./ass_goods_list.vue?vue&type=script&lang=js&"
export * from "./ass_goods_list.vue?vue&type=script&lang=js&"
import style0 from "./ass_goods_list.vue?vue&type=style&index=0&id=d01e4f4a&prod&lang=scss&"
import style1 from "./ass_goods_list.vue?vue&type=style&index=1&id=d01e4f4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01e4f4a",
  null
  
)

export default component.exports